import styled from 'styled-components'
import { Checkbox } from '@velasca/ui/checkbox'
import { InfoButton } from '@velasca/ui/info-button'

export const Wrapper = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: baseline;
  margin-top: 0.7rem;
`

export const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
`

export const StyledInfoButton = styled(InfoButton)`
  z-index: 1050;
`
